module.exports = __webpack_public_path__ + "static/img/beryl-nut_256.f40be6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beryl-nut_256.png
// module id = CA1c
// module chunks = 0